module.exports = __webpack_public_path__ + "img/hk.9502d71.svg";